import { render } from "./ProspectHeader.vue?vue&type=template&id=18033893"
import script from "./ProspectHeader.vue?vue&type=script&lang=js"
export * from "./ProspectHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__